<template>

      <div id="app">
		<div style="width:100%;">
			<img src="./assets/logo1.png" style="width:25%;display:inline-block;vertical-align:middle;">
			<span style="margin-left:2rem;">欢迎来到华兆益生</span>
		</div>
		<div style="margin-top:0.2rem;text-align:center;background-color:#eee;height:0.2rem;">
		</div>
		
 <router-view v-if="isRouterAlive"></router-view>
    </div>
</template>
<style>

  .el-message-box {
    width: 90% !important;
  }

    .rptframe {
		position:relative;
		width:90%;
		border:1px solid #ddd;
		border-radius:8px;
        box-shadow: 1px 1px 1px #888;
		text-align:center;
		margin:4px auto;
		background-color:white;
	}
    .tbl {
		width:90%;
		border:1px solid #ddd;
		border-radius:8px;
        box-shadow: 1px 1px 1px #888;
		margin:6px auto;
	}
</style>
<script>
export default {
  name: 'App',
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return{
      isRouterAlive:true
    }
  },
  methods:{
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(function(){
        this.isRouterAlive = true;
      })
    }
  }
}
</script>

